import { useTranslation } from 'react-i18next';

import { SmallHeading } from 'PDF/components/SmallHeading';
import { ISalesPlanTableProps } from 'PDF/pages/MarketingAndSales/types';

import { SalesPlanDetailsFooter } from './SalesPlanDetailsFooter';
import { SalesPlanDetailsProductRow } from './SalesPlanDetailsProductRow';
import { SalesPlanHeader } from './SalesPlanHeader';

export const SalesPlanDetailsTable = ({
  columns,
  rows,
  totalValues,
  currencySymbol,
  unit,
  isExamplePage,
}: ISalesPlanTableProps) => {
  const { t } = useTranslation();
  return (
    <>
      <SmallHeading heading={t('pdfPages.mappings.marketingAndSales.salesPlanDetails')} />
      <SalesPlanHeader date={columns} />
      {rows.map((product, index) => (
        <SalesPlanDetailsProductRow key={index} row={product} />
      ))}
      <SalesPlanDetailsFooter
        numbers={totalValues}
        currencySymbol={currencySymbol}
        unit={unit}
        isExamplePage={isExamplePage}
      />
    </>
  );
};
